export default "__VITE_ASSET__DjOxex9c__"